import _defineProperty from "D:/androidcode/zf_tms_vue/tms_vue/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.number.constructor";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { getData } from '@/api/down/down';
export default _defineProperty(_defineProperty({
  props: {
    options: {
      type: Object
    },
    data: {
      type: Object
    },
    value1: {
      type: String | Number
    }
  },
  created: function created() {
    console.log(229);
    console.log(this.value1, 229);
  },
  data: function data() {
    var _this = this;
    if (Object.prototype.hasOwnProperty.call(this.options, 'columnConfig')) {
      this.options.columnConfig.forEach(function (item) {
        if (!Object.prototype.hasOwnProperty.call(_this.data, item.prop)) {
          _this.$set(_this.data, item.prop, '');
        } else {
          _this.$set(_this.data, item.prop, _this.data[item.prop]);
        }
      });
    }
    return {
      showAll: false
    };
  },
  methods: {
    download: function download() {
      getData();
    },
    expand: function expand() {
      for (var i = 0; i < this.options.columnConfig.length; i++) {
        var element = this.options.columnConfig[i];
        if (Object.prototype.hasOwnProperty.call(element, 'showAll')) {
          this.$set(this.options.columnConfig[i], 'showAll', true);
          this.showAll = true;
        }
      }
    },
    packUp: function packUp() {
      for (var i = 0; i < this.options.columnConfig.length; i++) {
        var element = this.options.columnConfig[i];
        if (Object.prototype.hasOwnProperty.call(element, 'showAll')) {
          this.$set(this.options.columnConfig[i], 'showAll', false);
          this.showAll = false;
        }
      }
    },
    // 搜索
    search: function search() {
      this.$emit('search');
    },
    // refresh()
    refresh: function refresh() {
      this.$emit('refresh');
    }
  }
}, "created", function created() {
  var _this2 = this;
  if (!Object.prototype.hasOwnProperty.call(this.options, 'columnConfigSpan')) {
    this.$set(this.options, 'columnConfigSpan', 6);
  }
  if (!Object.prototype.hasOwnProperty.call(this.options, 'isDefaultBtn')) {
    this.$set(this.options, 'isDefaultBtn', true);
  }
  if (Object.prototype.hasOwnProperty.call(this.options, 'columnConfig')) {
    this.options.columnConfig.forEach(function (item, index) {
      if (!item.type) {
        _this2.$set(_this2.options.columnConfig[index], 'type', 'input');
      }
    });
  }
}), "watch", {
  data: {
    deep: true,
    immediate: true,
    handler: function handler(newV, old) {
      this.$emit('update:data', newV);
    }
  }
});